import { useEffect } from 'react'

const useDynamicFont = () => {
  useEffect(() => {
    const addFont = (fontUrl: string) => {
      if (!document.querySelector(`link[href="${fontUrl}"]`)) {
        const link = document.createElement('link')
        link.href = fontUrl
        link.rel = 'stylesheet'
        document.head.appendChild(link)
      }
    }
    const getFontUrl = (origin: string | null): string | null => {
      switch (origin) {
        case 'fused':
          return 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto&display=swap'
        case 'libeerer':
          return 'https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap'
        default:
          return null
      }
    }
    const origin = sessionStorage.getItem('origin')
    const fontUrl = getFontUrl(origin)
    if (fontUrl) {
      addFont(fontUrl)
    }
  }, [])
}

export default useDynamicFont
